export default "__VITE_ASSET__336ccdbd__"